import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Subscription } from 'rxjs/Rx';
import { ErrorHandlerService } from '../../services';
var SponsorThankyouComponent = /** @class */ (function () {
    function SponsorThankyouComponent(errorHandlerService, activatedRoute, dashboardService, router) {
        this.errorHandlerService = errorHandlerService;
        this.activatedRoute = activatedRoute;
        this.dashboardService = dashboardService;
        this.router = router;
        this.subscriptions = [];
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.proceedSponsorThankyou = {
            sponsorThankyoushipLevel: "Silver",
            benefits: "This is for test",
            amount: 100
        };
        this.queryData = {
            companyName: "",
            companyWebsite: "",
            companyLogo: "",
            level: "",
            sessionName: "",
            price: "",
            benefits: ""
        };
    }
    SponsorThankyouComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SponsorThankyouComponent.prototype.ngOnInit = function () {
        this.showSpinner = true;
        this.initFn();
    };
    SponsorThankyouComponent.prototype.initFn = function () {
        var _this = this;
        var s1 = this.activatedRoute.queryParams.subscribe(function (params) {
            _this.queryData.status = params['status'];
            if (_this.queryData.status == 'SUCCESS') {
                _this.queryData.companyName = params['companyName'];
                _this.queryData.companyWebsite = params['companyWebsite'];
                _this.queryData.companyLogo = params['companyLogo'];
                _this.queryData.level = params['level'];
                _this.getCourseDetail();
            }
        });
        this.subscriptions.push(s1);
    };
    SponsorThankyouComponent.prototype.getCourseDetail = function () {
        var _this = this;
        var s2 = this.activatedRoute.params.subscribe(function (params) {
            var sessionId = params['id'];
            if (sessionId != '0') {
                _this.dashboardService.getCourse(sessionId).subscribe(function (data) {
                    _this.queryData.sessionName = data.courseFullName;
                    if (data.sponsorshipLevels.length > 0) {
                        data.sponsorshipLevels.forEach(function (spl) {
                            if (spl.sponsorshipLevel == _this.queryData.level) {
                                _this.queryData.price = spl.amount;
                                _this.queryData.benefits = spl.benefits;
                            }
                        });
                    }
                    _this.showSpinner = false;
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
            }
            else {
                _this.router.navigate(['dashboard/home']);
                _this.showSpinner = false;
            }
            //this.showSpinner = false;
        });
        this.subscriptions.push(s2);
    };
    SponsorThankyouComponent.prototype.navigateURL = function (url) {
        if (url.substring(0, 4) != 'http') {
            url = "//" + url;
        }
        window.open(url, "_blank");
    };
    SponsorThankyouComponent.prototype.handleError = function (error) {
        //console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        //console.log("The URL of the error==>"+error.url);
        if (url == undefined) {
            return;
        }
        //console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    SponsorThankyouComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return SponsorThankyouComponent;
}());
export { SponsorThankyouComponent };
//# sourceMappingURL=sponsorThankyou.component.js.map